// removed by extract-text-webpack-plugin
module.exports = {"list":"List__list___1v02T","header":"List__header___t8aVs","title":"List__title___2mw7A _typography__h6___1u75q _typography__headers___eO5yD _typography__text-ellipsis___tUHkx","info":"List__info___1i6Q8 _typography__smallInfo___e4AsH _typography__headers___eO5yD","footer":"List__footer___P2MEa","footer-clean":"List__footer-clean___2qhNw List__footer___P2MEa","header-clean":"List__header-clean___1l4Gd List__header___t8aVs","body":"List__body___2ZV0x","body-padding":"List__body-padding___2IbWQ"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/Layout/List.scss
// module id = 547
// module chunks = 0